import React, { useState } from 'react';
import AdminSidebar from './components/AdminSidebar';
import Header from '../teacher_screen/components/Header';
import {
    Settings as SettingsIcon,
    Shield,
    Database,
    Globe,
    Bell,
    Users,
    Key,
    Save,
    ChevronRight,
    Lock,
    Eye,
    Server,
    Smartphone
} from 'lucide-react';

export default function AdminSettings() {
    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <AdminSidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="System Configuration"
                    subtitle="Primary administrative controls and institutional infrastructure settings"
                >
                    <button className="flex items-center gap-3 py-2.5 px-8 bg-blue-500 text-white rounded-xl text-[14px] font-black shadow-lg shadow-blue-200 hover:bg-blue-600 transition-all active:scale-95 uppercase tracking-tight">
                        <Save size={18} />
                        Apply & Restart
                    </button>
                </Header>

                <div className="max-w-6xl mb-10 pb-10">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                        {/* Core Modules */}
                        <div className="bg-white rounded-[32px] border border-gray-100 shadow-sm overflow-hidden">
                            <div className="p-8 border-b border-gray-50 flex items-center justify-between bg-[#F8FAFC]/50">
                                <div className="flex items-center gap-4">
                                    <div className="w-10 h-10 bg-white border border-gray-100 rounded-xl flex items-center justify-center shadow-sm">
                                        <Server size={18} className="text-blue-600" />
                                    </div>
                                    <h3 className="text-[18px] font-black text-[#111827] uppercase tracking-tight">System Modules</h3>
                                </div>
                                <span className="text-[10px] font-black bg-blue-500 text-white px-3 py-1 rounded-full uppercase tracking-widest">Active</span>
                            </div>
                            <div className="p-8 space-y-6">
                                <ModuleToggle label="Admission Gateway" active={true} />
                                <ModuleToggle label="Fee Portal Integration" active={true} />
                                <ModuleToggle label="Mobile App (Sync)" active={false} />
                                <ModuleToggle label="Library RFID System" active={false} />
                            </div>
                        </div>

                        {/* Security Policy */}
                        <div className="bg-white rounded-[32px] border border-gray-100 shadow-sm overflow-hidden">
                            <div className="p-8 border-b border-gray-50 flex items-center justify-between bg-[#F8FAFC]/50">
                                <div className="flex items-center gap-4">
                                    <div className="w-10 h-10 bg-white border border-gray-100 rounded-xl flex items-center justify-center shadow-sm">
                                        <Lock size={18} className="text-rose-500" />
                                    </div>
                                    <h3 className="text-[18px] font-black text-[#111827] uppercase tracking-tight">Security & Governance</h3>
                                </div>
                                <Shield size={18} className="text-gray-400" />
                            </div>
                            <div className="p-8 space-y-4">
                                <ActionRow icon={Key} label="Credential Policy" value="v2.4 Restricted" />
                                <ActionRow icon={Eye} label="System Audit Log" value="Retention: 3 Years" />
                                <ActionRow icon={Database} label="Redundant Backups" value="Daily @ 03:00 AM" />
                            </div>
                        </div>

                        {/* Communication */}
                        <div className="bg-[#111827] rounded-[32px] p-8 text-white flex items-center justify-between lg:col-span-2">
                            <div className="flex items-center gap-6">
                                <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center backdrop-blur-3xl border border-white/20">
                                    <Smartphone size={32} />
                                </div>
                                <div>
                                    <h3 className="text-[20px] font-black mb-1 leading-none uppercase tracking-tight">App Console Settings</h3>
                                    <p className="text-white/50 text-[14px] font-medium">Configure push notifications, branding and student access profiles.</p>
                                </div>
                            </div>
                            <button className="px-8 py-3 bg-blue-500 text-white rounded-xl text-[14px] font-black hover:bg-blue-600 transition-all shadow-xl shadow-blue-900/20 uppercase tracking-widest">Configure</button>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

function ModuleToggle({ label, active }) {
    return (
        <div className="flex items-center justify-between group cursor-pointer p-3 border border-transparent hover:border-gray-50 hover:bg-slate-50 rounded-2xl transition-all">
            <span className="text-[14px] font-black text-gray-700 group-hover:text-blue-500 transition-colors uppercase tracking-tight">{label}</span>
            <div className={`w-10 h-5 rounded-full relative transition-all ${active ? 'bg-blue-500 shadow-md shadow-blue-100' : 'bg-gray-200'}`}>
                <div className={`absolute top-0.5 w-4 h-4 bg-white rounded-full transition-all ${active ? 'right-0.5' : 'left-0.5'}`}></div>
            </div>
        </div>
    );
}

function ActionRow({ icon: Icon, label, value }) {
    return (
        <div className="flex items-center justify-between p-4 bg-slate-50/50 border border-gray-50 rounded-2xl hover:bg-blue-50/50 hover:border-blue-100 transition-all group cursor-pointer">
            <div className="flex items-center gap-4">
                <Icon size={18} className="text-gray-400 group-hover:text-blue-500 transition-colors" />
                <div>
                    <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest leading-none mb-1">{label}</p>
                    <p className="text-[14px] font-black text-gray-700 uppercase tracking-tight">{value}</p>
                </div>
            </div>
            <ChevronRight size={18} className="text-gray-300 group-hover:text-gray-900 transition-all" />
        </div>
    );
}
